export const ShareConfigType = Object.freeze({
    None : 0,
    商品分享标题设置 : 1,
    营销分享标题设置 : 2,
    其它分享标题设置 : 3,
    公众号推送标题设置 : 4,
});
export const ShareMarketingType = Object.freeze({
    None : 0,
    组合施工: 3,
    买套餐免单: 5,
    老带新成返差团: 6,
    老带新成生效团: 7,
    好评转介绍: 1,
    回馈卡兑换套餐: 2,
    回馈卡活动: 4,
});
export const ShareOtherType = Object.freeze({
    None : 0,
    首页 : 1,
    预约 : 2,
    评价 : 3,
    排队取号 : 4
});
export const ShareType = Object.freeze({
    None : 0,
    列表页 : 1,
    详情页 : 2,
    评价无礼券 : 3,
    评价得红包 : 4,
    评价得现金券 : 5
});
export const ShareSceneType = Object.freeze({
    None : 0,
    购买前 : 1,
    购买后 : 2,
});
export default {
    ShareConfigType,
    ShareMarketingType,
    ShareOtherType,
    ShareType,
    ShareSceneType
}